'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteLogo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'site-logo';

function SiteLogo() {
  var logoBankingCareer = _react2.default.createElement(
    'svg',
    { width: '46', height: '70', viewBox: '20 8 46 70', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M28 77.22c1.55-1.6 3.26-3.1 4.55-4.86 1.06-1.43 1.88-3.17 2.3-4.9.56-2.3-.48-4.4-2.25-5.83-2.58-2.1-5.38-3.9-8.08-5.82-.96-.68-2-1.3-2.83-2.1-2.36-2.27-2.3-5.15.43-6.9 2.1-1.35 4.52-2.34 6.92-3.03 3.2-.92 6.55-1.4 9.84-2.08l.07.34c-1.56.63-3.18 1.15-4.7 1.9-1.34.68-2.68 1.5-3.84 2.46-1.2 1-1.22 2.3-.02 3.28 1.14.9 2.47 1.74 3.85 2.15 5.28 1.6 10.63 2.95 15.92 4.5 3.76 1.1 7.4 2.52 10.56 4.9 4.24 3.15 5.3 7.12 3.18 11.9-1.78 4.03-1.87 4.1-6.26 4.1H28z', fill: '#FFF' }),
      _react2.default.createElement('path', { className: 'mark', d: 'M46.38 21.3c-.02 2.8 2.38 5.2 5.2 5.18 2.76-.02 5.1-2.33 5.16-5.08.05-2.83-2.28-5.2-5.14-5.23-2.84-.03-5.2 2.3-5.22 5.13m5.3 25.6c-1.5-2.68-2.8-5.37-4.46-7.8-1.75-2.6-3.9-4.9-5.78-7.4-3.5-4.63-4.74-9.73-2.53-15.26 2.2-5.5 7.8-8.83 13.66-8.4 5.84.43 10.93 4.58 12.3 10.28 1.26 5.36-.44 10-3.8 14.24-2.5 3.16-4.92 6.4-7.2 9.73-.97 1.4-1.5 3.1-2.18 4.6', fill: '#4D4D4D' }),
      _react2.default.createElement('path', { className: 'mark', d: 'M60.6 21.03c0 4.98-4.06 9.02-9.06 9.02-5 0-9.06-4.04-9.06-9.02 0-4.98 4.06-9.02 9.06-9.02 5 0 9.05 4.05 9.05 9.03', fill: '#4D4D4D' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M51.04 15.42l2.08 4.2 4.64.66-3.36 3.26.8 4.6-4.16-2.17-4.15 2.17.8-4.6-3.37-3.26 4.64-.67' })
    )
  );

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    logoBankingCareer
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteLogo/SiteLogo.jsx
// module id = 1129
// module chunks = 0